import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const DEFAULT_HERO = "https://images.pexels.com/photos/16309117/pexels-photo-16309117.jpeg?auto=compress&cs=tinysrgb&w=1600";

// Shared image-background page header (matches the program-detail hero).
export function PageHero({ image, eyebrow, title, description, icon: Icon, back = true, testid = "page-hero", action = null }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const homeLabel = { en: "Home", cs: "Domů", he: "דף הבית", ru: "Главная" }[lang] || "Home";
  const src = image ? resolveImg(image) : DEFAULT_HERO;

  return (
    <section className="relative pt-24 sm:pt-28" data-testid={testid}>
      <div className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={src} alt={title || ""} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/45 to-[#0F172A]/15" />
        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto max-w-7xl w-full px-5 sm:px-8 pb-10">
            {back && (
              <button onClick={() => navigate("/")} data-testid={`${testid}-back`}
                className="flex w-fit items-center gap-2 text-sm text-white/80 hover:text-white mb-5 transition-colors">
                <ArrowLeft size={16} className="rtl:rotate-180" /> {homeLabel}
              </button>
            )}
            {eyebrow && (
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#BE923C]">
                {Icon && <Icon size={15} />} {eyebrow}
              </span>
            )}
            <h1 className="mt-3 font-serif text-4xl sm:text-6xl tracking-tight text-white leading-[0.98] max-w-3xl">{title}</h1>
            {description && <p className="mt-4 max-w-2xl text-white/85 text-base sm:text-lg leading-relaxed">{description}</p>}
            {action && <div className="mt-6">{action}</div>}
          </div>
        </div>
      </div>
    </section>
  );
}
